import React from 'react';
import { joinClasses } from '../../../../Utils/className.util';
import styles from './TextAreaModule.module.scss';
import { Position } from '../../../../Modules/Base/Enums/Position.enum';
import AudioToText from '../../../../Modules/Base/Components/AudioToText/AudioToText';

export interface TextAreaProps {
	className?: string;
	rows?: number;
	value?: string;
	onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
	hasError?: boolean;
	disabled?: boolean;
	charactersLimit?: number;
	placeholder?: string;
	style?: React.CSSProperties;
	captureAudio?: {
		allow: boolean;
		position: Position;
	};
}

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
	({
		className,
		rows = 3,
		onChange,
		value,
		hasError = false,
		disabled,
		charactersLimit,
		placeholder,
		style,
		captureAudio,
	}: TextAreaProps) => {
		const handleAudioCapture = (capturedValue: string) => {
			if (!onChange) {
				return;
			}

			onChange({
				target: { value: capturedValue },
				currentTarget: { value: capturedValue },
			} as React.ChangeEvent<HTMLTextAreaElement>);
		};

		return (
			<div
				className={joinClasses([
					styles.wrapper,
					captureAudio?.position === Position.LEFT
						? styles.withAudioLeft
						: styles.withAudioRight,
				])}>
				{captureAudio?.allow && (
					<AudioToText
						value={value}
						onCapture={handleAudioCapture}
						position={captureAudio.position}
					/>
				)}
				<textarea
					className={joinClasses([
						styles.textArea,
						className,
						hasError ? styles.invalid : undefined,
					])}
					rows={rows}
					value={value}
					onChange={onChange}
					disabled={disabled}
					maxLength={charactersLimit}
					placeholder={placeholder}
					style={style}
				/>
			</div>
		);
	},
);

export default TextArea;
